import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/styles.scss';export default {
  "fileSystem": "_fileSystem_gketd_1",
  "loader": "_loader_gketd_10",
  "loaderMain": "_loaderMain_gketd_18",
  "header": "_header_gketd_23",
  "content": "_content_gketd_30",
  "main": "_main_gketd_35",
  "path": "_path_gketd_42",
  "documentsType": "_documentsType_gketd_47",
  "uploadDocumentButton": "_uploadDocumentButton_gketd_64",
  "icon": "_icon_gketd_80"
};